import _ from 'lodash'
import * as Collections from 'typescript-collections'
import moment from 'moment'
import Flatten from 'flatten-js'
// import atob from 'atob'
import forge from 'node-forge'

export class Dict extends Collections.Dictionary {}

export class FrozenDict extends Collections.Dictionary {}

// *****************************************************************************

export function round_value(nb) {
  const inb = parseInt(nb)
  if (nb === inb) {
    return inb.toString()
  } else {
    return Number.parseFloat(nb)
      .toFixed(4)
      .toString()
  }
}

// *****************************************************************************

export function formatted_integer_with_thousand_spaces(nb) {
  return nb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export function formatted_moment_localized(dt, locale) {
  // console.log(locale)
  let res = moment(dt)
  res.locale(locale)
  res = res.calendar()
  return res
}

// *****************************************************************************

// // N.B : Not used for now
export function extended_dict_invert(d) {
  let res = new Dict()
  d = init_extended_dict(d)
  d.forEach((k, v) => {
    res.setValue(v, k)
  })
  return res
}

function init_extended_dict(d) {
  return _.isUndefined(d) || _.isEmpty(d) ? new Dict() : d
}

export function extended_dict_size(d) {
  d = init_extended_dict(d)
  return d.size()
}

export function extended_dict_keys(d) {
  d = init_extended_dict(d)
  return d.keys()
}

export function extended_dict_values(d) {
  d = init_extended_dict(d)
  return d.values()
}

export function extended_dict_items(d) {
  d = init_extended_dict(d)
  return _.zip(d.keys(), d.values())
}

export function extended_dict_forEach(d, f) {
  d = init_extended_dict(d)
  d.forEach(f)
}

export function dict_from_frozendict(d) {
  let res = {}
  d.forEach((k, v) => {
    res[k] = v
  })
  return res
}

// // N.B : Not used for now
export function frozendict_from_dict(d) {
  let res = new FrozenDict()
  for (let k in d) {
    res.setValue(k, d[k])
  }
  return res
}

export function extended_dict_getValue(d, k) {
  let res = undefined
  if (!(_.isUndefined(d) || _.isEmpty(d))) {
    res = d.getValue(k)
  }
  return res
}

// *****************************************************************************

export function enclosing_box(a) {
  const res = a.reduce((acc, o) => acc.merge(o.box), new Flatten.Box())
  return res
}

export function enclosing_large_box(a) {
  const res = a.reduce((acc, o) => acc.merge(o.large_box), new Flatten.Box())
  return res
}

export function constrain_translate_box(b, a) {
  // This function prevents box a from escaping box b bounds and will
  // translate box a as much as required so that it stays within b bounds
  // Will be used for constraining movement while translating bricks
  // out of the workflow
  // let res = new Flatten.Box(a.xmin, a.ymin, a.xmax, a.ymax)
  let res = a.clone()
  if (!b.merge(a).equal_to(b)) {
    if (a.xmin < b.xmin) {
      res.xmin = b.xmin
      res.xmax += b.xmin - a.xmin
    }
    if (a.ymin < b.ymin) {
      res.ymin = b.ymin
      res.ymax += b.ymin - a.ymin
    }
    if (a.xmax > b.xmax) {
      res.xmax = b.xmax
      res.xmin += b.xmax - a.xmax
    }
    if (a.ymax > b.ymax) {
      res.ymax = b.ymax
      res.ymin += b.ymax - a.ymax
    }
  }
  return res
}

export const workflow_grid_step = 16
export const workflow_brick_size = workflow_grid_step * 5
export const workflow_brick_icon_size = workflow_grid_step * 3

// *****************************************************************************

// export function is_dispatch_parametrized(list_tables_dispatch) {
//   console.log(JSON.stringify(list_tables_dispatch))
//   let is_not_parametrized = _.filter(list_tables_dispatch, [
//     'metavariables_expressions',
//     '',
//   ])
//   let res = _.isEmpty(is_not_parametrized)
//   console.log(res)
//   return res
// }

// *****************************************************************************

// https://stackoverflow.com/questions/4810841/how-can-i-pretty-print-json-using-javascript
export function json_syntax_highlight(json) {
  // console.log('json_syntax_highlight')
  json = json
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
    function(match) {
      let cls = 'number'
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key'
        } else {
          cls = 'string'
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean'
      } else if (/null/.test(match)) {
        cls = 'null'
      }
      cls = 'synaplus-cosmo-json-highlight-' + cls
      return '<span class="' + cls + '">' + match + '</span>'
    }
  )
}

// *****************************************************************************

export function cumsum(arr) {
  // Returns an array of the same size than arr
  // The first entry is the first element of arr
  // The last entry is the total sum of the numbers in arr
  function builder(acc, n) {
    const last_num = acc.length > 0 ? acc[acc.length - 1] : 0
    acc.push(last_num + n)
    return acc
  }
  return _.reduce(arr, builder, [])
}

export function lowerbound(arr, a) {
  // For an array which is [16, 32, 48, 64]
  // 15 -> 0
  // 16 -> 1
  let res = _.sortedIndex(arr, a + 1)
  return res
}

export function next_power_of_two(n) {
  // next_power_of_two(100) === 128
  // next_power_of_two(50)  === 64
  // next_power_of_two(8)   === 8
  if (n === 0) return 1
  --n
  n |= n >> 1
  n |= n >> 2
  n |= n >> 4
  n |= n >> 8
  n |= n >> 16
  n |= n >> 32
  return n + 1
}

export function gcd(x, y) {
  while (y) {
    const t = y
    y = x % y
    x = t
  }
  return x
}

// *****************************************************************************

export const justification_enum = Object.freeze({
  low: 1,
  middle: 2,
  high: 4,
})

// *****************************************************************************

export function bytes_to_human(bytes, si) {
  const step = si ? 1000 : 1024
  if (Math.abs(bytes) < step) {
    return bytes + ' B'
  }
  let units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  let u = -1
  do {
    bytes /= step
    ++u
  } while (Math.abs(bytes) >= step && u < units.length - 1)
  return bytes.toFixed(1) + ' ' + units[u]
}

// *****************************************************************************

export function scrolly_into_view(container, element) {
  const container_top = container.scrollTop()
  const container_bottom = container_top + container.height()
  const elem_top = element[0].offsetTop
  const elem_bottom = elem_top + element.height()
  if (elem_top < container_top) {
    container.scrollTop(elem_top)
  } else if (elem_bottom > container_bottom) {
    container.scrollTop(elem_bottom - container.height())
  }
}

// *****************************************************************************

export const notification_type_to_variant = Object.freeze({
  error: 'danger',
  warning: 'warning',
  info: 'info',
})

// *****************************************************************************

export const global_auth_groups = ['admin', 'user']

export const global_auth_groups_enum = Object.freeze({
  admin: 0,
  user: 1,
})

export const global_group_from_id = _.invert(global_auth_groups_enum)

// *****************************************************************************

export const project_auth_groups = ['admin', 'writer', 'reader']

export const project_auth_groups_enum = Object.freeze({
  admin: 0,
  writer: 1,
  reader: 2,
})

export const project_group_from_id = _.invert(project_auth_groups_enum)

// *****************************************************************************

export function aes_256_ctr_encrypt(plaintext, key, nonce, ctr) {
  const key_size = 256 / 8
  const block_size = 128 / 8
  const ctr_size = 32 / 8
  const nonce_size = block_size - ctr_size

  if (key.length !== key_size) {
    throw 'Invalid key length'
  }
  if (nonce.length !== nonce_size) {
    throw 'Invalid nonce length'
  }
  if (ctr.length !== ctr_size) {
    throw 'Invalid ctr length'
  }

  const ctr_block = nonce + ctr
  const header = ctr_block.slice(0)

  const plaintext_buffer = forge.util.createBuffer()
  plaintext_buffer.putBytes(plaintext)

  const cipher = forge.cipher.createCipher('AES-CTR', key)
  cipher.start({ iv: ctr_block })
  cipher.update(plaintext_buffer)
  cipher.finish()

  const ciphertext = cipher.output.bytes()
  const message = header + ciphertext
  return message
}

export function encrypt_string(text, key, encoding = 'utf8') {
  const block_size = 128 / 8
  const ctr_size = 32 / 8
  const nonce_size = block_size - ctr_size

  const nonce = forge.random.getBytesSync(nonce_size)
  const ctr = forge.random.getBytesSync(ctr_size)

  if (!_.isString(text)) {
    // console.log(text)
    // console.log(typeof text)
    throw Error('Not a string')
  }
  const binary_string = Buffer.from(text, encoding).toString('binary')
  const binary_message = aes_256_ctr_encrypt(binary_string, key, nonce, ctr)
  const message = Buffer.from(binary_message, 'binary').toString('base64')
  return message
}

export function encrypt_object_fields_as_strings(
  obj,
  encryption_key,
  { unencrypted_field_names = [] } = {}
) {
  // console.log('unencrypted field names: ', unencrypted_field_names)
  // console.log('obj:', obj)
  const res = {}
  for (const field_name of _.keys(obj)) {
    // console.log('field_name:', field_name)
    if (unencrypted_field_names.includes(field_name)) {
      // console.log('in')
      res[field_name] = obj[field_name]
    } else {
      // console.log('out')
      res[field_name] = encrypt_string(obj[field_name], encryption_key)
    }
  }
  return res
}

// *****************************************************************************

export function aes_256_ctr_decrypt(message, key) {
  const block_size = 128 / 8
  const ctr_size = 32 / 8
  const nonce_size = block_size - ctr_size

  const nonce = message.slice(0, nonce_size)
  const ctr = message.slice(nonce_size, nonce_size + ctr_size)
  const ciphertext = message.slice(nonce_size + ctr_size)

  const header_and_plaintext = aes_256_ctr_encrypt(ciphertext, key, nonce, ctr)
  const plaintext = header_and_plaintext.slice(nonce_size + ctr_size)

  return plaintext
}

// export function decrypt_binary_string(message, key) {
//   return aes_256_ctr_decrypt(message, key)
// }

export function decrypt_string(message, key, encoding = 'utf8') {
  const binary_message = Buffer.from(message, 'base64').toString('binary')
  const binary_plaintext = aes_256_ctr_decrypt(binary_message, key)
  const plaintext = Buffer.from(binary_plaintext, 'binary').toString(encoding)
  return plaintext
}

export function decrypt_object_fields_as_strings({
  encrypted_obj,
  encryption_key,
  unencrypted_field_names = [],
} = {}) {
  let res = {}
  for (const field_name of _.keys(encrypted_obj)) {
    if (unencrypted_field_names.includes(field_name)) {
      res[field_name] = encrypted_obj[field_name]
    } else {
      res[field_name] = decrypt_string(
        encrypted_obj[field_name],
        encryption_key
      )
    }
  }
  return res
}

// *****************************************************************************

export function platform_encrypt_string(plaintext, encoding = 'utf8') {
  let platform_key = Buffer.from(
    '6aCjKw0VjhDkcqWTaSfobnQhaNrgrBBFrHBzN5akFU0=',
    'base64'
  ).toString('binary')
  let message = encrypt_string(plaintext, platform_key, encoding)
  return message
}

export function platform_decrypt_string(message, encoding = 'utf8') {
  let platform_key = Buffer.from(
    '6aCjKw0VjhDkcqWTaSfobnQhaNrgrBBFrHBzN5akFU0=',
    'base64'
  ).toString('binary')
  let plaintext = decrypt_string(message, platform_key, encoding)
  return plaintext
}

// *****************************************************************************
